// extracted by mini-css-extract-plugin
module.exports = {"info":"info-2oZcetpx","hardAd":"hardAd-2GuzBlGx"};